import React from 'react';

const BrandName = ({ className = '', size = 'base' }) => {
  const sizeClasses = {
    sm: 'text-sm',
    base: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl',
    '2xl': 'text-2xl',
    '3xl': 'text-3xl',
  };

  return (
    <span className={`${sizeClasses[size]} ${className}`}>
      <span className="text-brand-navy font-bold">Plan</span>
      <span className="text-brand-gray font-bold">Source</span>
    </span>
  );
};

export default BrandName;